import { propertyQueryKeys as e } from "../properties/usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { roomsApi as r } from "@maat/api-main";
//#region src/rooms/useDeleteRoomMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteRoom(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.property() }), i.invalidateQueries({ queryKey: e.room() }), i.invalidateQueries({ queryKey: e.unit() });
		}
	});
};
//#endregion
export { i as useDeleteRoomMutation };
